import {
  DisplayFormErrors,
  FileUploadField,
  InputField,
  EfsMelcoModelsUserAlphabet,
  VerticalForm,
  Drawer as DrawerType,
  DebugForm,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { QueryObserverResult } from "react-query";
import { SavePublishHeader } from "../../header/SavePublishHeader";
import { useRevertFont } from "../../../hooks/libraries/fonts/useRevertFont";
import { useFontReferencesCount } from "../../../hooks/libraries/fonts/useFontReferencesCount";
import {
  Col,
  DesignTokens,
  FullWidthSpace,
  LabeledItem,
  PreviewSider,
  Row,
  Title,
} from "melco-ui";
import { useField } from "formik";

const { spacings } = DesignTokens;

type DisplayFontDetailFormProps = {
  font: EfsMelcoModelsUserAlphabet;
  refetch: () => Promise<
    QueryObserverResult<EfsMelcoModelsUserAlphabet, unknown>
  >;
  referencesDrawer: DrawerType;
};

export const DisplayFontDetailForm: React.FC<DisplayFontDetailFormProps> = ({
  font,
  refetch,
  referencesDrawer,
}) => {
  const {
    id,
    publish_state: publishState,
    created_date: createdDate,
    updated_date: updatedDate,
    publish_date: publishDate,
    warning_list: warningList,
  } = font;

  const { t } = useTranslation();
  const [revertFont, isLoading] = useRevertFont(id!, refetch);

  const { total: referencesCount } = useFontReferencesCount(id!);

  const [{ value: type }] = useField("type");
  const [{ value: serviceName }] = useField("service_name");

  return (
    <>
      <SavePublishHeader
        revertAction={revertFont}
        isCurrentlyReverting={isLoading}
        publishedState={publishState!}
        createdDate={createdDate!}
        updatedDate={updatedDate}
        publishedDate={publishDate}
        warnings={warningList ?? undefined}
        referencesCount={referencesCount}
        referencesDrawer={referencesDrawer}
      />

      <Row gutter={[spacings.xlarge, spacings.xlarge]}>
        <Col xs={16}>
          <VerticalForm>
            <DisplayFormErrors />

            <InputField
              name="name"
              label={t("libraries.fonts.detail.form.label.name")}
            />

            <FileUploadField
              name="file"
              label={t("libraries.fonts.detail.form.label.file")}
              maxFiles={1}
            />

            <InputField
              name="recommended_text"
              label={t("libraries.fonts.detail.form.label.recommended_text")}
              maxLength={50}
            />
          </VerticalForm>
        </Col>
        <Col xs={8}>
          <PreviewSider data-cy-id="font-detail-sider">
            <FullWidthSpace direction="vertical" size="small">
              <Title level={5}>
                {t("libraries.fonts.detail.info_sider.title")}
              </Title>

              <LabeledItem
                label={t("libraries.fonts.detail.info_sider.type")}
                content={type}
                fallback={t("global.fallback.none")}
              />

              <LabeledItem
                label={t("libraries.fonts.detail.info_sider.service_name")}
                content={serviceName}
                fallback={t("global.fallback.none")}
              />
            </FullWidthSpace>
          </PreviewSider>
        </Col>
      </Row>

      {false && <DebugForm />}
    </>
  );
};
